import * as styles from "./SalesChartFilters.module.scss";

const SalesChartFilters = ({ children }) => {
  return <div className={styles.Sales_Chart_Filter}>{children}</div>;
};

export default SalesChartFilters;
